import axios from 'axios';
import React, { useEffect, useState, Fragment } from 'react'
import Constants from '../../../Constants';
import APIUrls from '../../../services/APIUrls';
import { downloadFile, getAxiosResponse, postAxiosResponse, putAxiosResponse } from '../../../services/authApiRoutes/APImethods';
import { dateFormat } from '../../../services/Util';
import Select, { components } from 'react-select';
import $ from 'jquery'
import { RotatingLines } from 'react-loader-spinner';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { logError } from '../../../services/authApiRoutes/APImethods';
import { AttachmentIcon_Height_21, CrossIcon } from '../../../AppIcons';
import { ConditionalBlock } from '../../../ConditionalBlock';

const chunkSize = Constants.CHUNK_SIZE;
export default function DiscussionOverviewPopup(prop) {
    const projectId = prop.id;
    const vendorName=prop.vendorName;
    const targetAssetId = prop.targetAssetId;
    const userGroupId = prop.userGroupId;
    const { t } = useTranslation();
    const [chatText,setChatText] = useState("");
    const [selectedfile, setSelectedFile] = useState(null);
    const [messageAndEventList, setMessageAndEventList] = useState(null);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [topicFollowers, setTopicFollowers] = useState([]);
    const [isEditing, setIsEditing] = useState(false);
    const [documentFileId, setDocumentFiledId] = useState(-1);
    const [currentChunkIndex, setCurrentChunkIndex] = useState(-1);
    const [fileUploadProgress, setFileUploadProgress] = useState(0);
    const [mystate, setMyState] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);
    const [allUsers, setAllUsers] = useState([]);
    const [name, setName] = useState("");
    const [selectedFollowers, setSelectedFollowers] = useState([]);
    const [topic, setTopic] = useState({});
    const [refreshPage, setRefreshPage] = useState(false);
    const [showEdit, setShowEdit] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const [showEditLoader, setShowEditLoader] = useState(false);
    const [followers,setFollowers] = useState([]);
    const [departmentFollowers, setDepartmentFollowers] = useState([]);

    const owner = useSelector((loginSessionDetail) => loginSessionDetail.loginSession).value;

    const sendMessage = async () => {
        if (chatText !== Constants.BLANK) {
          setTimeout(() => {
            $('.sending_msg').trigger('focus')
          }, 100);
          setShowLoader(true);
          
         const params = getParams();
          const url = `${APIUrls.CUSTOMER_PROJECT_TRANSLATION_TRANSLATED_ASSETS_DISCUSSION(projectId,targetAssetId , "json")}?${params.toString()}`;
          try {
            const response = await postAxiosResponse(url);
            if (response.data.data) {
              setDocumentFiledId(response.data.data);
             }
            setCurrentChunkIndex(0);
          } catch (error) {
            const errorMessage = "Error while sending message:";
            logError(errorMessage, error);   
          }
          
        }
    };

    const getParams = () => {
        let params = new URLSearchParams();
        params.set("projectId", projectId);
        params.set("text", chatText);
        params.set("projectTranslationAssetId", targetAssetId);
        if (selectedfile) {
          params.set("name", selectedfile.name);
          params.set("size", selectedfile.size);
          params.set("currentChunkIndex", currentChunkIndex);
          params.set("totalChunks", Math.ceil(selectedfile.size / chunkSize));
          params.set("fileDataAttribute", "attachment.fileData");
          params.set("attachment.filename", selectedfile.name);
          params.set("attachment.sizeInKilobytes", selectedfile.size);
        }
        params.set("hasDocument", selectedfile ? true : false);
        params.set("documentFileId", (documentFileId !== -1) ? documentFileId : "");
        return params;
    };

    const downloadAttachment = (fileName,messageId) => {
        const url = APIUrls.PROJECT_FILE_ATTACHMENT(projectId, targetAssetId, messageId);
        downloadFile(url, fileName);
    };

    const enterKeydownloadAttachment = (event,fileName,messageId)=>{
      if (event.key === Constants.ENTER) {
        const url = APIUrls.PROJECT_FILE_ATTACHMENT(projectId, targetAssetId, messageId);
        downloadFile(url, fileName);
      }
  }

    const downloadFeedbackAttachment = (fileId,projectId,fileName) => {
      const url = APIUrls.DOWNLOAD_FILE(fileId, "PROJECT", projectId);
      downloadFile(url, fileName);
      };

    const enterKeydownloadFeedbackAttachment = (event,fileId,projectId,fileName)=>{
      if (event.key === Constants.ENTER) {
        const url = APIUrls.DOWNLOAD_FILE(fileId, "PROJECT", projectId);
        downloadFile(url, fileName);
      }
    }

    const handleEdit = () => {
      showDropdown ? setShowDropdown(false) : setShowDropdown(true)
      populateNotifyUsers(true,true);
      // setShowDropdown(true);
       setIsEditing(true);
      $('.follower-expand').attr('aria-expanded', function(index, attr){
        return attr === 'true' ? 'false': 'true';
      });
    };

    const handleCancel = () => {
      setShowDropdown(false);
      setSelectedFollowers([]);
      setIsEditing(false);
      $('.follower-expand').attr('aria-expanded', function(index, attr){
        return attr === 'true' ? 'false': 'true';
      });
      $('.follower-expand').trigger('focus')
    };

    const handleRemoveTag = (selected) => {
      let updatedstate = mystate.filter((user) => user.value !== selected.value);
      setMyState(updatedstate)
      setAllUsers([...allUsers, selected])
    };

    const addFollower = () => {
      setShowEditLoader(true);
      const followerToAdd = selectedFollowers.map((selectedUser) => ({
        customerUser: {
          userId: selectedUser.value,
        }
      }));
      topicFollowers.forEach((val)=>{
        followerToAdd.push({
          customerUser: {
            userId: val.value
          }
        })
      });
      const topicObj = {
        id: topic.id,
        followers: followerToAdd,
      };
      putAxiosResponse(APIUrls.UPDATE_PROJECT_FOLLOWER(projectId, targetAssetId), topicObj)
      .then((res) => {
        setShowEditLoader(false);
        setRefreshPage(refreshPage ? false : true);
        setSelectedFollowers([]);
        setShowDropdown(false);
        setIsEditing(false);
        $('.follower-expand').attr('aria-expanded', function(index, attr){
          return attr === 'true' ? 'false': 'true';
        });
      })
      .catch((err) => {
        console.error(err);
      });
    };

    useEffect(() => {
        getMessages();
        fetchProjectFollowers();
        fetchDepartmentFollowers();
    }, [refreshPage,targetAssetId]);
  
    const getMessages = () => {
        getAxiosResponse(APIUrls.CUSTOMER_PROJECT_TRANSLATION_TRANSLATED_ASSETS_DISCUSSION(projectId, targetAssetId, "json"))
        .then(res => {
            const eventList = res.data?.data?.messageAndEventList;
            const topc = res.data?.data?.topic;
            setTopic(topc);
            let data = eventList?.sort((o1,o2)=>{
                return (o2.date.utcTimestamp)-(o1.date.utcTimestamp);
            });
            setMessageAndEventList(data);
            const follower = res.data?.data?.topic.followers;
            const forcedFollowers = res.data?.data?.topic.forcedFollowers;
            const ids = follower.filter(obj => obj.vendor).map(obj => obj.vendor.name);
            const users = follower.filter(obj => obj.customerUser)
                                  .map((obj) => ({
                                    label: `${obj.customerUser.firstName} ${obj.customerUser.lastName}`,
                                    displayName: `${obj.customerUser.firstName} ${obj.customerUser.lastName}(${obj.customerUser.roleSet.displayName})`,
                                    value: obj.customerUser.userId, isOwner: obj.customerUser.userId === owner.id, isForced:false
                                  }));
            forcedFollowers && forcedFollowers.forEach((obj)=>{
              let forcedUser = users.find((user)=>user.value === obj.userId);
              if(!forcedUser){
                users.push({
                  label: `${obj.firstName} ${obj.lastName}`,
                  displayName: `${obj.firstName} ${obj.lastName}(${obj.roleSet.displayName})`,
                  value: obj.userId, isOwner: obj.userId === owner.id, isForced:true
                });
              }
            });
            if (users.length > 0) {
              setTopicFollowers(users);
            }
            if (ids !== null) {
              setName(ids.join(","));
            }
            $('.cancelDiscussionPopup').trigger('focus');
           setShowLoader(false);
         });
    };

    const uploadChunkFile = (readerEvent) => {
        const file = selectedfile;
        const data = readerEvent ? readerEvent.target.result : {};
        const headers = {
        "Content-Type": "application/octet-stream",
        "CSRF-Token": localStorage.getItem("csrfToken")
        };
        let params = getParams();
        const url1 = `${APIUrls.CUSTOMER_PROJECT_TRANSLATION_TRANSLATED_ASSETS_DISCUSSION(projectId, targetAssetId, "htm")}?${params.toString()}`;
        const urlPart = (file ? `/upload${url1}` : `${url1}`);
        const url = `${process.env.REACT_APP_BACKEND_SERVER}${urlPart}`;
        axios.post(url, data, { headers }).then((response) => {
        if (response?.data?.code === 200) {
          if (selectedfile) {
            const filesize = selectedfile.size;
            const chunks = Math.ceil(filesize / chunkSize) - 1;
            const isLastChunk = currentChunkIndex === chunks;
            if (isLastChunk) {
                setCurrentChunkIndex(-1);
                setRefreshPage(refreshPage ? false : true);
                setChatText("");
                setSelectedFile("");
            }
            else {
                const chunks = Math.ceil(filesize / chunkSize);
                setFileUploadProgress(Math.round((currentChunkIndex / chunks) * 100));
                setCurrentChunkIndex(currentChunkIndex + 1);
            }
          }
          else {
            setCurrentChunkIndex(-1);
            setRefreshPage(refreshPage ? false : true);
            setChatText("");
            setSelectedFile("");
          }
        }
      });
    };

    useEffect(() => {
      if (currentChunkIndex !== -1) {
        readAndUploadCurrentChunkFile();
      }
    }, [currentChunkIndex]);

  // Function to read and upload current chunk of selected file
    const readAndUploadCurrentChunkFile = () => {
      const file = selectedfile;
      if (file) {
        const reader = new FileReader();
        const from = currentChunkIndex * chunkSize;
        const to = from + chunkSize;
        const blob = file.slice(from, to);
        reader.onload = (e) => uploadChunkFile(e);
        reader.readAsDataURL(blob);
        } else {
        uploadChunkFile(null);
      }
    };

    // useEffect(() => {
    //     populateNotifyUsers(true,true);
    // }, [followers,departmentFollowers]);

  const fetchProjectFollowers = ()=>{
    getAxiosResponse(APIUrls.PROJECT_FOLLOWER_USER(projectId))
    .then((res) => {
      if (res.data.code === 200) {
        let users = res.data.data.filter((resource)=> (owner.id !== resource.resource.userId))
        .map(({ resource,displayName }) => ({value: resource.userId,
            label: resource.firstName+' '+resource.lastName+' ('+displayName[0]?.roles[0]+')', isVendor:false
          }));
          setFollowers(users);
        }
      })
      .catch((err) => {
        console.error(err);
    });
  };
  
  const fetchDepartmentFollowers = () =>{
      getAxiosResponse(APIUrls.PROJECT_VISIBILITY_USER(projectId))
      .then((res) => {
        if (res.data.code === 200) {
          let users = res.data.data.filter((resource)=>(owner.id !== resource.userId))
          .map(({ resource,displayName }) => ({
                value: resource.userId,
                label: resource.firstName+' '+resource.lastName+' ('+displayName[0].displayName+')',isVendor:false
              }));

        setDepartmentFollowers(users);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };
  
  const populateNotifyUsers = (isFollower,isDeptFollower)=>{
      let data = [];
      if(isFollower){
        data.push({key: "1",value: "all-follower",label: "-- Select All Project Followers --"});
        followers.forEach((follower)=>{
          let tFollwer = topicFollowers.find((tf)=>(tf.value === follower.value));
          let sFollower = selectedFollowers.find((sf)=>(sf.value === follower.value));
          if(!tFollwer && !sFollower){
            data.push(follower);
          }
        });
      }
      if(isDeptFollower){
        data.push({key: "2",value: "other-dept-users",label: "-- Other Users In Department --"});
        departmentFollowers.forEach((user)=>{
          let follower = followers.find((val)=>(val.value === user.value));
          let tFollwer = topicFollowers.find((tf)=>(tf.value === user.value));
          let sFollower = selectedFollowers.find((sf)=> (sf.value === user.value));
          if(!follower && !tFollwer && !sFollower){
            data.push(user);
          }
        });
      }
      setAllUsers(data);
  };

  const handleNotifyUserChange = (event) => {
    let selectedId = event.value;
    let array = []
    if (event.value === "all-follower") {
      array = [...selectedFollowers,...followers];
    }
    else if(event.value === "other-dept-users"){
      array = [...selectedFollowers,...departmentFollowers];
    }else {
      let result = allUsers.find(({ value }) => value == selectedId);
      array = [...selectedFollowers,result];
    }
    let finalArray = [];
    let filterArray = array.filter((obj)=>{
      let follower = topicFollowers.find((tf)=>tf.value === obj.value);
      return !follower
    });
    filterArray.forEach((obj)=>{
      let foll = finalArray.find((fa)=> fa.value === obj.value);
      !foll && finalArray.push(obj);
    });
    if(filterArray.length){
      let set = Array.from(new Set(finalArray));
      setSelectedFollowers(set);
    }
  };

  const removeSelectedItem = (follower)=>{
    let data = selectedFollowers.filter((sf)=>(sf.value !== follower.value));
    setSelectedFollowers(data);
    const selectedElement = $(document.activeElement).closest(".multiselect-output");
    if($(document.activeElement).is(':last-child') &&
      selectedElement.children().length > 1){
        selectedElement.find('button:nth-last-child(2)').trigger('focus');
    } else if($(document.activeElement).is(':last-child')){
      $(document.activeElement).closest(".topic-followers").find('.global-dropdown-block input:first-of-type').trigger('focus');
    }
  };

  useEffect(()=>{
    populateNotifyUsers(true,true);
  },[selectedFollowers]);

  const removeTopicFollower = (follower)=>{
    let data = topicFollowers.filter((tf)=>(tf.value !== follower.value));
    setTopicFollowers(data);
    populateNotifyUsers(true,true);
    const selectedElement = $(document.activeElement).closest(".multiselect-output");
    if($(document.activeElement).is(':last-child') &&
      selectedElement.children().length > 1){
        selectedElement.find('button:nth-last-child(2)').trigger('focus');
    } else if($(document.activeElement).is(':last-child')){
      $(document.activeElement).closest(".topic-followers").find('.global-dropdown-block input:first-of-type').trigger('focus');
    }
  };

  const hideModell = () => {
    showEdit ? setShowEdit(false) : setShowEdit(true);
    document.body.classList.remove("modal-open");
  };

  const handleDiscussionCancel = (e)=>{
    prop.showChatBox(false,null);
  }

  return (
    <>
    <div className='lightbox-panel icr-lightbox' aria-labelledby="removelabel" aria-modal="true" role="dialog">
        <div className="inner-lightbox-panel pb-0">
            <div className="modal-header flex padd-lr">
                <h5 id="removelabel">Discussion and Notifications Activity</h5>
            </div>
        <div className="lightbox-content padd-22">
            <div className="flex">
                <div className="left-activity">
                    <div className='filter-content-labelHeading'>
                      <label htmlFor="message">Discussion & Activity</label>
                      <textarea maxLength="2500" className="textarea discusstionTextarea" name='notes' id="message" placeholder="2500 characters limit " value={chatText} onChange={(e) => setChatText(e.target.value)}></textarea>
                    </div>
                    <div className="flex justify-end">
                    {showLoader? (
                      <div className='sending_msg' aria-label='Sending in progress' tabIndex="0">
                        <RotatingLines strokeColor="#1D4ED8" strokeWidth="5" animationDuration="0.75" width="22" visible={true} />
                     </div>
                    ):(
                       <button id='sendMsg' className="blue-btn active" onClick={sendMessage}>Send Message</button> 
                      
                    )}
                    </div>
                    <div className="wrap">
                    <div className="input-text-file">
                        <input type="file" id="attachment" onChange={(e) => setSelectedFile(e.target.files[0])} />
                        <label className="file-button" htmlFor="attachment">Add attachment</label>
                    </div>
                    <div className="upload-status"><span>{selectedfile?.name}</span></div>
                    <div><span>Maximum file size: 50MB. Create a zip file to upload multiple files.</span></div>
                    </div>
                    <ul style={{height:"200px",overflow:"scroll"}}>
                    {messageAndEventList?.map((item) => {
                        return (
                        <li>
                            {item?.event &&
                            <div className="icr-automated-chat">
                                <div>{t("event_type."+item?.event?.type)}</div>
                                <div>
                                  <strong>{item?.event?.creatorDisplayName} </strong>
                                   <span className='font-zero'>{item?.event?.createdDate?.dateWithTime}</span>
                                   <span aria-hidden="true">{item?.event?.createdDate?.dateWithTime}</span>
                                  </div>
                            </div>
                            }
                            {(item?.message || item?.feedback) &&
                            <div className="icr-popup-chat">
                                <div>
                                  <strong>{item?.message?.creatorDisplayName || `${item?.feedback?.creatorUser?.firstName} ${item?.feedback?.creatorUser?.lastName}`}</strong>{" "}
                                  {(item?.message?.creatorOrganization?.name || topic?.creatorOrganization?.name )}  
                                  <span className='font-zero'>{item?.message?.createdDate?.dateWithTime || item?.feedback?.createdDate?.dateWithTime}</span>
                                  <span aria-hidden="true"> {item?.message?.createdDate?.dateWithTime || item?.feedback?.createdDate?.dateWithTime}</span>
                                </div>
                                <div>{item?.message?.text || item?.feedback?.feedback}</div>
                                
                                {item?.message.attachment ?
                                  <div>
                                    <a tabIndex="0" className="attach-breakText" aria-label={"download " + `${item?.message.attachment.filename}`}
                                    onClick={() => downloadAttachment(item?.message.attachment.filename,item.message?.id)}
                                    onKeyDown={(e)=>enterKeydownloadAttachment(e,item?.message.attachment.filename,item.message?.id)}
                                    >
                                      <span className='attachment-icon'>
                                        {AttachmentIcon_Height_21}
                                      </span>
                                      {item?.message?.attachment?.filename}
                                    </a>
                                  </div> 
                                  : Constants.BLANK}
                                     <div>{item?.message?.attachment?.fileName}</div>

                                  {(item?.feedback?.attachment) ?
                                  <div>
                                    <a tabIndex="0" className="attach-breakText" aria-label={"download " + `${(item?.feedback?.attachment?.filename)}`}
                                    onClick={() => downloadFeedbackAttachment(item?.feedback?.attachment?.fileId, item?.feedback?.attachment?.project?.id,item?.feedback?.attachment?.filename)}
                                    onKeyDown={(e)=>enterKeydownloadFeedbackAttachment((e,item?.feedback?.attachment?.filename ), (item?.feedback?.id))}
                                    >
                                      <span className='attachment-icon'>
                                        {AttachmentIcon_Height_21}
                                      </span>
                                      {item?.feedback?.attachment?.filename}
                                    </a>
                                  </div> 
                                  : Constants.BLANK}
                                     <div>{item?.feedback?.attachment?.fileName}</div>                             
                            </div>
                            }
                        </li>
                        )
                    }
                    )}

                    </ul>
                </div>
                <div className="right-activity">
                    <h6>Notifications</h6>
                    <div className="topic-followers">
                    <label>Who is following this?</label>
                    {/* <button className="topic-follower-edit"   onClick={handleEdit} >Edit h </button> */}
                    <div className="multiselect-edit-user">
                        <div className="multiselect-output flex mar-bot15 justify-end">
                          
                          {topicFollowers.map((user,index) => {
                              return (
                                <>
                                {isEditing ?
                                  (
                                    <button key={index} aria-label={"remove " + user.displayName}>
                                      <strong>{" "}{user.displayName}</strong>
                                      {!user.isForced && 
                                        <span onClick={()=>removeTopicFollower(user)}>
                                          {CrossIcon}
                                        </span>
                                      }
                                    </button>
                                  ):
                                  <>
                                    <ConditionalBlock condition={(index === topicFollowers.length-1)}>
                                      <span key={index}>&nbsp;{user.label}</span>
                                    </ConditionalBlock>
                                    <ConditionalBlock condition={(index !== topicFollowers.length-1)}>
                                      <span key={index}>&nbsp;{`${user.label},`}&nbsp;</span>
                                    </ConditionalBlock>
                                  </>
                                }
                                </>
                              )
                          })}
                         {
                          selectedFollowers.map((follower,index)=>{
                            return (
                              <>
                              <button key={index} aria-label={"remove " + follower.label}>
                                <strong>{" "}{follower.label}</strong>
                                  <span onClick={()=>removeSelectedItem(follower)}>
                                    {CrossIcon}
                                  </span>
                              </button>
                              </>
                            )
                          })
                         }
                        </div> 
                        <ConditionalBlock condition={showDropdown === false}>
                          <button className="topic-follower-edit follower-expand" aria-expanded="false" onClick={handleEdit}>Edit</button>
                        </ConditionalBlock>
                        {showDropdown ? (
                            <div className="global-dropdown-block">
                                <Select menuShouldScrollIntoView={false} closeMenuOnSelect={true} classNamePrefix='cw'
                                className="global-dropdown-select escCloseDropdown mar-bot15" options={allUsers}
                                value={{value:"",label:"Select a User"}}
                                hideSelectedOptions={true}
                                onChange={handleNotifyUserChange} 
                                aria-label="add followers" />
                                <div className="multiselect-output flex">
                                  {mystate && mystate.length > 0 &&
                                      mystate.map((tags, index) => (
                                        <button key={index}>
                                            <strong>{tags}</strong>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="9" viewBox="0 0 10 9" fill="none" onClick={() => handleRemoveTag(tags)} >
                                              <path d="M1.50391 7.99067L4.99924 4.49533M8.49457 1L4.99857 4.49533M4.99857 4.49533L1.50391 1M4.99924 4.49533L8.49457 7.99067" stroke="#213248" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" ></path>
                                            </svg>
                                        </button>
                                      )
                                    )
                                  }
                                </div>
                                <div style={{ display: "flex", alignItems: "center" }}>
                                {showEditLoader? (
                                  <div>
                                    <RotatingLines strokeColor="#1D4ED8" strokeWidth="5" animationDuration="0.75" width="22" visible={true} />
                                  </div>
                                ):(
                                  <div>
                                    <button aria-label="cancel edit" className="blue-btn" onClick={handleCancel} style={{ marginRight: "10px" }}>
                                      Cancel
                                    </button>
                                    <button aria-label="save edit" className="blue-btn active" onClick={addFollower} style={{ marginLeft: "10px" }}>Save</button>
                                  </div>
                                )
                              }
                                </div>
                            </div>
                        ) : (
                        ''
                        )}
                        
                        <div className="flex justify-end btn-gap mar-bot16">

                        </div>
                    </div>
                    <div className="topic-bottom">
                      `{vendorName ? (
                        <Fragment>
                          <strong>{vendorName}</strong>
                          <span> is included in this thread</span>
                        </Fragment>
                      ) : (
                        <Fragment>
                          <strong>{name}</strong>
                          <span> is included in this thread</span>
                        </Fragment>
                      )}
                      </div>`
                    </div>
                </div>
            </div>
        </div>
        <div className="modal-footer modal-footer-border flex px-22">
            <button className="btn btn-bold active cancelDiscussionPopup" onClick={(e) => {handleDiscussionCancel(e);$("body").removeClass("modal-open");}}>Close</button>
        </div>
        </div>
    </div>
    </>
  )
}
